<template>
  <div v-if="userPermission">
    <div v-if="!loading">
      <b-form>
        <div>
          <b-tabs no-nav-style nav-class="secondary-tabs">
            <b-tab
              :title="$t('tabs.general')"
              class="p-5"
              @click.prevent="updateVisibleSubmit(true)"
            >
              <clients-form />
            </b-tab>
            <b-tab
              v-if="editCompany"
              :title="$t('tabs.contacts')"
              class="p-5"
              @click.prevent="updateVisibleSubmit(true)"
            >
              <contacts-tab />
            </b-tab>
            <edit-actions
              route-name="clientsList"
              :is-visible-submit="isVisibleSubmit"
              @save="submit"
            />
          </b-tabs>
        </div>
      </b-form>
    </div>
  </div>
  <div
    v-else
    class="w-100 h-100 d-flex align-items-center justify-content-center"
  >
    <p class="fs-18 font-weight-bold">
      {{ $t("messages.dont_have_permission") }}
    </p>
  </div>
</template>

<script>
import clientsForm from '@/components/clients/form'
import contactsTab from '@/components/clients/contacts/tab'
import editActions from '@/components/common/editActions'
import model from '@/models/clients'
import edit from '@/mixins/edit'
import permissions from '@/mixins/permissions'
import api from '@/api/clients'

export default {
  components: {
    clientsForm,
    contactsTab,
    editActions
  },
  mixins: [edit, permissions],
  data: () => ({
    api,
    loading: true,
    model: JSON.parse(JSON.stringify(model.empty)),
    rules: model.rules,
    isVisibleSubmit: true
  }),
  computed: {
    editCompany() {
      return this.$route.name && this.$route.name === 'clientsUpdate'
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      if (this.$route.params.id) {
        await this.getItem()
      } else {
        this.initForm(this.model)
      }

      this.loading = false
    },
    updateVisibleSubmit(value) {
      this.isVisibleSubmit = value
    }
  },
  validations: {
    ...model.rules
  }
}
</script>
